import '@/styles/globals.css'

// Runtime configuration bootstrap.
//
// In the container, /config.json is served from a mounted ConfigMap (see
// halobiz-devops: client-portal-ui/deployment/charts/<env>/templates/configmap.yaml).
// It MUST be loaded into window.__APP_CONFIG__ BEFORE any module that reads `env`
// (e.g. @/lib/msalInstance) is evaluated — otherwise env.ts throws for the missing
// VITE_MSAL_* values. Static imports are hoisted and run before the module body, so
// App and msalInstance are pulled in via dynamic import AFTER config is loaded.
async function bootstrap() {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' })
    if (res.ok) {
      window.__APP_CONFIG__ = await res.json()
    }
  } catch {
    // No runtime config file (e.g. local dev) — fall back to build-time import.meta.env.
  }

  const rootElement = document.getElementById('root')
  if (!rootElement) throw new Error('Root element #root not found in index.html')

  const { StrictMode } = await import('react')
  const { createRoot } = await import('react-dom/client')
  const { default: App } = await import('./App')
  const { msalInstance } = await import('@/lib/msalInstance')

  // MSAL v5 requires initialize() before any other API use, and the redirect
  // promise must resolve before the app renders so accounts are populated.
  await msalInstance.initialize()
  await msalInstance.handleRedirectPromise()

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
